/**
 * Two-Panel Mega Menu Navigation
 * Handles hover/click interactions for category tabs
 */

(function() {
  'use strict';

  function initTwoPanelMenus() {
    const containers = document.querySelectorAll('.mega-menu__nav--two-panel');

    containers.forEach(container => {
      if (container.dataset.initialized === 'true') return;

      const tabs = container.querySelectorAll('.mega-menu__category-tab');
      const panels = container.querySelectorAll('.mega-menu__panel-content');

      if (tabs.length === 0 || panels.length === 0) return;

      container.dataset.initialized = 'true';

      function switchToPanel(index) {
        tabs.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add('is-active');
            tab.style.backgroundColor = 'rgba(0,0,0,0.06)';
            tab.style.fontWeight = '600';
          } else {
            tab.classList.remove('is-active');
            tab.style.backgroundColor = 'transparent';
            tab.style.fontWeight = '500';
          }
        });

        panels.forEach((panel, i) => {
          if (i === index) {
            panel.classList.add('is-active');
            panel.style.display = 'block';
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('is-active');
            panel.style.display = 'none';
          }
        });
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('mouseenter', () => switchToPanel(index));
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          switchToPanel(index);
        });
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            switchToPanel(index);
          } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const next = index < tabs.length - 1 ? index + 1 : 0;
            tabs[next].focus();
            switchToPanel(next);
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = index > 0 ? index - 1 : tabs.length - 1;
            tabs[prev].focus();
            switchToPanel(prev);
          }
        });
      });

      switchToPanel(0);
    });
  }

  // Primary trigger: when a mega menu details element opens, init after
  // the browser has painted (rAF ensures the inserted HTML is accessible)
  document.addEventListener('toggle', function(event) {
    const details = event.target.closest?.('details') || (event.target.tagName === 'DETAILS' ? event.target : null);
    if (details && details.open) {
      requestAnimationFrame(initTwoPanelMenus);
    }
  }, true);

  // Fallback: catch AJAX-inserted content via MutationObserver
  const observer = new MutationObserver(() => {
    if (document.querySelector('.mega-menu__nav--two-panel:not([data-initialized])')) {
      requestAnimationFrame(initTwoPanelMenus);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial run + theme editor reloads
  document.addEventListener('DOMContentLoaded', initTwoPanelMenus);
  document.addEventListener('shopify:section:load', initTwoPanelMenus);

})();
